import * as Commons from "oc-commons/Commons";
import React from "react";
import { OptionPage } from "../torkonfigurator/OptionPage";
import { Konfiguration } from "../torkonfigurator/Konfiguration";
import { Masse } from "../torkonfigurator/Masse";
import { OptionMenu } from "../torkonfigurator/OptionMenu";
import { OptionenContentDekorprofile } from "../torkonfigurator/OptionenContentDekorprofile";
import { getRichProfilkategorien } from "../arrangement/elementFunctions";
import { E_Antrieb_Zubehoer } from "../torkonfigurator/E_Antrieb_Zubehoer";
import { Abschluss } from "../torkonfigurator/Abschluss";
import { ausrichtungCode } from "../components/TorEigenschaften";

interface Vector3Like {
  x: number;
  y: number;
  z: number;
}

/**
 * Einzige Seite des Torkonfigurators. Hier wird das OptionMenu aufgebaut, welches
 * durch die gesamte Konfiguration führt.
 */
export class Masseditor extends React.Component {
  pageNeeds = {
    scene: true,
    background: false,
    form: true,
    pageTypeForCssAnimation: 4,
  };

  cameraConfigSaved: {
    object: Vector3Like;
    target: Vector3Like;
    up: Vector3Like;
  };
  enableZaunSelection = false;
  fadedIn = false;

  async init({
    pageEnteredInSequence,
    pageBeforeNeeds,
  }: {
    pageEnteredInSequence: boolean;
    pageBeforeNeeds: { zaun?: boolean };
  }) {
    this.pageNeeds.background = pageBeforeNeeds.zaun;
    APP.arrangement.visible = false;
    APP.arrangement.jaco3d.visible = false;
    // für smoothe Anims etwas warten
    await this.zaunansichtAnimation(pageEnteredInSequence);
    APP.pageFadeIn(pageEnteredInSequence);
    APP.controls.enabled = true;
    APP.arrangement.zauneditorReady = true;
    APP.dirty();
    APP.undoHandler.enabled = false;
  }

  async zaunansichtAnimation(pageEnteredInSequence: boolean) {
    APP.resetShadowPlane();
    this.pageNeeds.background = true;
    const backgroundObjects = APP.getSceneBackgroundObjects().filter(
      (o) => o.name != "shadowPlane"
    );
    backgroundObjects.forEach((o) => (o.opacity = 0));
    APP.trigger("SceneBackgroundChange");

    // if (!APP.testmode && !APP.arrangement.isBackupForZauneditorComparisonSame()) {
    //   APP.arrangement.fillWithElementsMaybeFromStoreAndRemoveElementsOutside();
    // }

    APP.arrangement.visible = true;
    APP.arrangement.jaco3d.visible = true;
    APP.arrangement.opacity = 0;
    APP.arrangement.jaco3d.opacity = 0;
    await APP.tween(
      (t: number) => {
        APP.arrangement.opacity = t;
        APP.arrangement.jaco3d.opacity = t;
        backgroundObjects.forEach((o) => (o.opacity = t));
      },
      pageEnteredInSequence ? 800 : 200
    );

    await APP.zoomCameraToPart(null, true);

    await Commons.sleep(pageEnteredInSequence ? 200 : 1);
  }

  getFüllungOptionen(konf: Konfiguration) {
    const result = ["Füllung"];
    if (konf.isZaungitter()) {
      result.push("Zaungitter");
    }
    if (konf.isSenkrechtprofileMöglich()) {
      result.push("Senkrechtprofile");
    }

    return result;
  }

  getAusrichtungOptionen(konf: Konfiguration) {
    const ausrichtungOptionen = [];

    if (!konf.isSchiebetor()) {
      ausrichtungOptionen.push("Öffnung");
    }

    if (konf.isDoppeltor()) {
      ausrichtungOptionen.push("Gehflügel");
    } else if (konf.isDreifachtor()) {
      ausrichtungOptionen.push("Gehflügel");
      ausrichtungOptionen.push("Position_Einzeltor");
    } else if (konf.isSchiebetor()) {
      ausrichtungOptionen.push("Schiebetormotorseite");
      ausrichtungOptionen.push("Schieberichtung");
    } else {
      ausrichtungOptionen.push("Anschlag");
    }

    const passendeFüllungsseiten = konf.getPassendeAuswahlwerte("Füllungsseite");
    if (passendeFüllungsseiten.length > 1) ausrichtungOptionen.push("Füllungsseite");

    return ausrichtungOptionen;
  }

  getZubehoerOptionen(konf: Konfiguration) {
    const zubehoerOptionen = [];

    // if (konf.isAnschlagProfilNotwendig()) zubehoerOptionen.push("Anschlagprofil"); // TODO: Mass3d Mauer implementieren

    const passendeElementhalter = konf.getPassendeAuswahlwerte("Elementhalter");
    if (passendeElementhalter.length > 1) zubehoerOptionen.push("Elementhalter");

    const passendeAufsatzleiste = konf.getPassendeAuswahlwerte("Aufsatzleiste");
    if (passendeAufsatzleiste.length > 1) zubehoerOptionen.push("Aufsatzleiste");

    if (!konf.isAnMauerBeide()) {
      zubehoerOptionen.push("Bodenbefestigung");
      zubehoerOptionen.push("Pfostenfarbe");
    }
    if (konf.isTorWorkflow()) {
      zubehoerOptionen.push("Beschlagsatz");
      zubehoerOptionen.push("Toröffner");
      zubehoerOptionen.push("Torschließer");

      if (konf.currentElement.getWandmontagePlatten().length > 0) {
        zubehoerOptionen.push("Anschlagprofilfarbe");
      }
      if (konf.currentElement.hasAnschlagprofil) {
        zubehoerOptionen.push("Anschlagprofil");
      }

      if (!konf.isDoppeltorEAntrieb()) {
        zubehoerOptionen.push("Einsteckschloss");
        zubehoerOptionen.push("Drücker");
        zubehoerOptionen.push("Profilzylinder");
      }
    }

    return zubehoerOptionen;
  }

  render() {
    const konf = APP.arrangement?.konfiguration;
    if (!konf) return <></>;

    const element = konf.currentElement;
    if (!element) return <></>;

    const isWorkflowVerstecken = false;
    const isSerieZuerst = false;
    const workflowOptionContent =
      isWorkflowVerstecken || APP.isZaunConfigurationMode ? null : (
        <OptionPage key={"Workflow"} title={"Workflow"} optionen={["Workflow", "AnMauer"]} />
      );
    const serieOptionContent = APP.isZaunConfigurationMode ? null : (
      <OptionPage key={"Serie"} title={"Serie"} optionen={["DetailSerie"]} />
    );
    const firstOptionContent = isSerieZuerst ? serieOptionContent : workflowOptionContent;
    const secondOptionContent = isSerieZuerst ? workflowOptionContent : serieOptionContent;

    const isTorWorkflow = konf.isTorWorkflow();
    const füllungOptionen = this.getFüllungOptionen(konf);
    const ausrichtungOptionen = this.getAusrichtungOptionen(konf);
    const zubehoerOptionen = this.getZubehoerOptionen(konf);

    const ausrichtungsCode = ausrichtungCode(
      konf.isDreifachtor() ? konf.currentElementEinzeltor : element
    );

    return (
      <>
        <OptionMenu showFooter={true} aria-label={I18N("aria::Optionenmenü")} role="navigation">
          {firstOptionContent}
          {secondOptionContent}

          <OptionPage
            key={"Füllung"}
            title={element.getFüllungName()}
            optionen={füllungOptionen}
            optionenTitleKeys={["Füllung", konf.isZaungitter() ? "Zaungitter" : null]}
            hide={
              konf.getPassendeAuswahlwerte("Füllung").length < 2 &&
              getRichProfilkategorien(true).length < 2
            }
          >
            <OptionenContentDekorprofile />
          </OptionPage>

          <OptionPage
            key={"Rahmen"}
            title={"Rahmen"}
            optionen={["Rahmen"]}
            hide={konf.getPassendeAuswahlwerte("Rahmen").length < 2}
          />

          <Masse key={"Mass"} title={"Mass"} />

          {isTorWorkflow && (
            <OptionPage key={"Ausrichtung"} title={"Ausrichtung"} optionen={ausrichtungOptionen}>
              <div
                className="ausrichtung_image_container"
                id={"TorOptionen"}
                role="img"
                aria-label={I18N("aria::Tor-Ausrichtungsdiagramm")}
              >
                <div
                  className={`image ausrichtung_image ausrichtung_${ausrichtungsCode}`}
                  aria-hidden="true"
                >
                  <div>{konf.isSchiebetor() ? I18N("Seite 1") : I18N("innen")}</div>
                  <div>{konf.isSchiebetor() ? I18N("Seite 2") : I18N("außen")}</div>
                </div>
              </div>
            </OptionPage>
          )}

          {zubehoerOptionen.length > 0 && (
            <OptionPage key={"Zubehör"} title={"Zubehör"} optionen={zubehoerOptionen}>
              {(konf.isDoppeltorEAntrieb() || konf.isSchiebetor()) && <E_Antrieb_Zubehoer />}
            </OptionPage>
          )}

          <Abschluss key={"Abschluss"} title={"Abschluss"} />
        </OptionMenu>
      </>
    );
  }
}
